import { OrderFormValue } from './index';
var OrderFormBank = /*@__PURE__*/ (function () {
    function OrderFormBank() {
    }
    OrderFormBank.prototype.getBankName = function () {
        return this.bank_name;
    };
    OrderFormBank.prototype.setBankName = function (bankName) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(bankName)
            .setValid(true)
            .setErrors(null)
            .setMin(1)
            .setMax(50)
            .setMand('Y')
            .setType('string|numeric');
        this.bank_name = formValue;
        return this;
    };
    OrderFormBank.prototype.getBankInstitut = function () {
        return this.bank_institut;
    };
    OrderFormBank.prototype.setBankInstitut = function (bankInstitut) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(bankInstitut)
            .setValid(true)
            .setErrors(null)
            .setMin(1)
            .setMax(50)
            .setMand('Y')
            .setType('string|numeric');
        this.bank_institut = formValue;
        return this;
    };
    OrderFormBank.prototype.getBankIban = function () {
        return this.bank_iban;
    };
    OrderFormBank.prototype.setBankIban = function (bankIban) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(bankIban)
            .setValid(true)
            .setErrors(null)
            .setMin(22)
            .setMax(35)
            .setMand('Y')
            .setType('string|numeric');
        this.bank_iban = formValue;
        return this;
    };
    OrderFormBank.prototype.getBankBic = function () {
        return this.bank_bic;
    };
    OrderFormBank.prototype.setBankBic = function (bankBic) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(bankBic)
            .setValid(true)
            .setErrors(null)
            .setMin(8)
            .setMax(11)
            .setMand('Y')
            .setType('string|numeric');
        this.bank_bic = formValue;
        return this;
    };
    OrderFormBank.prototype.getBankSepaApproval = function () {
        return this.bank_sepa_approval;
    };
    OrderFormBank.prototype.setBankSepaApproval = function (bankSepaApproval) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(bankSepaApproval)
            .setValid(true)
            .setErrors(null)
            .setMin(2)
            .setMax(3)
            .setMand('N')
            .setType('selection[Ja|Off]');
        this.bank_sepa_approval = formValue;
        return this;
    };
    return OrderFormBank;
}());
export { OrderFormBank };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.form-bank.ts
// module id = null
// module chunks = 